;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();type AutomationExecutionsKeyParams = {
	automationId?: string;
	params?: unknown;
	workspaceId?: string;
};

type AutomationExecutionKeyParams = {
	automationId?: string;
	executionId?: string;
	workspaceId?: string;
};

export const etlAutomationQueryKeys = {
	all: ["etl-automation"] as const,
	detail: ({
		automationId,
		workspaceId,
	}: {
		automationId?: string;
		workspaceId?: string;
	}) => ["etl-automation", workspaceId, automationId] as const,
	execution: ({
		automationId,
		executionId,
		workspaceId,
	}: AutomationExecutionKeyParams) =>
		[
			...etlAutomationQueryKeys.executionAll,
			workspaceId,
			automationId,
			executionId,
		] as const,
	executionAll: ["automation-execution"] as const,
	executions: ({
		automationId,
		params,
		workspaceId,
	}: AutomationExecutionsKeyParams) =>
		[
			...etlAutomationQueryKeys.executionsPrefix({
				automationId,
				workspaceId,
			}),
			{ params },
		] as const,
	executionsAll: ["automation-executions"] as const,
	executionsPrefix: ({
		automationId,
		workspaceId,
	}: {
		automationId?: string;
		workspaceId?: string;
	}) =>
		[
			...etlAutomationQueryKeys.executionsAll,
			workspaceId,
			automationId,
		] as const,
	executionsWorkspacePrefix: (workspaceId: string) =>
		[...etlAutomationQueryKeys.executionsAll, workspaceId] as const,
	executionWorkspacePrefix: (workspaceId: string) =>
		[...etlAutomationQueryKeys.executionAll, workspaceId] as const,
	list: (workspaceId?: string) => ["etl-automations", workspaceId] as const,
	operation: (operationId?: string) =>
		["automation-operation", operationId] as const,
	operations: ({
		provider,
		workspaceId,
	}: {
		provider?: string;
		workspaceId?: string;
	}) => ["automation-operations", workspaceId, provider] as const,
	providers: ({
		operationId,
		workspaceId,
	}: {
		operationId?: string;
		workspaceId?: string;
	}) => ["automation-providers", workspaceId, operationId] as const,
	supportLocks: (workspaceId: string) =>
		[...etlAutomationQueryKeys.supportLocksAll, workspaceId] as const,
	supportLocksAll: ["automation-support-locks"] as const,
	supportRunStates: (workspaceId: string) =>
		[...etlAutomationQueryKeys.supportRunStatesAll, workspaceId] as const,
	supportRunStatesAll: ["automation-support-run-states"] as const,
	supportStuckExecutions: (workspaceId: string) =>
		[...etlAutomationQueryKeys.supportStuckExecutionsAll, workspaceId] as const,
	supportStuckExecutionsAll: ["automation-support-stuck-executions"] as const,
	supportSyncStates: (workspaceId: string) =>
		[...etlAutomationQueryKeys.supportSyncStatesAll, workspaceId] as const,
	supportSyncStatesAll: ["automation-support-sync-states"] as const,
};

export const etlAutomationMutationKeys = {
	cancelExecution: ["etl-automation", "cancel-execution"] as const,
	create: ["etl-automation", "create"] as const,
	createDraft: ["etl-automation", "create-draft"] as const,
	delete: ["etl-automation", "delete"] as const,
	downloadExecutionArtifact: ["execution-artifact-download"] as const,
	duplicate: ["etl-automation", "duplicate"] as const,
	pause: ["etl-automation", "pause"] as const,
	publish: ["etl-automation", "publish"] as const,
	publishDetail: (automationId: string) =>
		["etl-automation", "publish", automationId] as const,
	reset: ["etl-automation", "reset"] as const,
	resume: ["etl-automation", "resume"] as const,
	retryExecution: ["etl-automation", "retry-execution"] as const,
	run: ["etl-automation", "run"] as const,
	update: (automationId: string) =>
		["etl-automation", "update", automationId] as const,
	updateDraft: (automationId: string) =>
		["etl-automation", "update-draft", automationId] as const,
};
